import { BACKEND_URL } from "@/utils/constants";
import axios from "axios";
import { useEffect, useState } from "react";

function FloatingBannerHome() {
  const [isVisible, setIsVisible] = useState(true);
  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const res = await axios.get(`${BACKEND_URL}/adminsetup/admin/floating-banner/getbanners`);
      const banners = res.data.data;

      const activeBanner = banners.find(
        (item) => item.isEnabled === true && item.isFloatingBanner === "true"
      );

      setBannerData(activeBanner);
    } catch (err) {
      console.error("Failed to fetch banner data", err);
    }
  }

  if (!isVisible || !bannerData) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-50 flex justify-center h-[12vh] ">
      <div className="bg-[#FFF8E7] border border-yellow-300 shadow-xl  px-4 py-3 w-full   relative flex justify-center items-center text-center">
        
        {/* Main Content Row */}
        <div className="flex items-center flex-wrap justify-center gap-2 sm:gap-3">
          <span className="text-2xl">🎊</span>
          <p className="text-xl text-gray-800 font-medium">
            {bannerData.content}
          </p>
          {bannerData.url && (
            <button className="border  px-4 rounded-lg bg-blue-600">
            <a
              href={bannerData.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white font-semibold hover:underline"
            >
              {bannerData.buttonContent || "Learn More"}
            </a>
            </button>
          )}
        </div>

        {/* Close Button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-3 text-gray-500 hover:text-red-500 font-bold text-lg leading-none"
        >
          x
        </button>
      </div>
    </div>
  );
}

export default FloatingBannerHome;
